import {_API, _AXIOS_HELPER, _HEADER} from "@/static";
import * as ENUM from "@/enum/lib";

export default {
    getManagerInfoFromServer() {
        return new Promise((resolve, reject) => {
            const url = _API + `/manager/getManagerInfo`;
            const conf = {
                headers: _HEADER()
            };
            _AXIOS_HELPER(ENUM.HTTP_METHOD.POST, url, {}, conf)
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    updateManagerInfoToServer(info) {
        return new Promise((resolve, reject) => {
            const url = _API + `/manager/updateManagerInfo`;
            const conf = {
                headers: _HEADER()
            };
            let data = {
                managerName: info.managerName,
                managerImageUrl: info.managerImageUrl,
                managerESignatureImageUrl: info.managerESignatureImageUrl,
                managerSpecialty: info.managerSpecialty,
                managerBackground: info.managerBackground,
                managerLanguageList: info.managerLanguageList,
                managerProfessionalEducation: info.managerProfessionalEducation,
                managerYearsOfExperience: info.managerYearsOfExperience
            };

            try {
                if (data.managerImageUrl === undefined)
                    delete data.managerImageUrl;
            } catch (e) {

            }

            try {
                if (data.managerESignatureImageUrl === undefined)
                    delete data.managerESignatureImageUrl;
            } catch (e) {

            }

            _AXIOS_HELPER(ENUM.HTTP_METHOD.PUT, url, data, conf)
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    updatePenaltyInfo(data) {
        return new Promise((resolve, reject) => {
            const url = _API + '/manager/updatePenaltyInfo';
            const conf = {
                headers: _HEADER()
            }
            _AXIOS_HELPER(ENUM.HTTP_METHOD.PUT, url, data, conf)
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                })
        });
    },
    changePassword(data) {
        return new Promise((resolve, reject) => {
            const url = _API + `/user/changePasswordBySeqUserAndCurrentPW`;
            const conf = {
                headers: _HEADER()
            };
            _AXIOS_HELPER(ENUM.HTTP_METHOD.PUT, url, data, conf)
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    updateFcmToken(token) {
        return new Promise((resolve, reject) => {
            // don't call updateToken if we don't have an access token
            const currentAccess = localStorage.getItem('accessToken');
            if (!currentAccess) {
                return resolve({data: {isSuccess: false, message: 'no access token'}});
            }

            const url = _API + `/user/updateToken`;
            const conf = {
                headers: _HEADER()
            };
            const data = {fcmToken: token}
            _AXIOS_HELPER(ENUM.HTTP_METHOD.PUT, url, data, conf)
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    mailTo(data) {
        return new Promise((resolve, reject) => {
            const url = _API + `/board/inquiry/clinic`;
            const conf = {
                headers: _HEADER()
            };
            _AXIOS_HELPER(ENUM.HTTP_METHOD.POST, url, data, conf)
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    inquirySave(data) {
        return new Promise((resolve, reject) => {
            const url = _API + `/board/inquiry/save`;
            const conf = {
                headers: _HEADER()
            };
            _AXIOS_HELPER(ENUM.HTTP_METHOD.POST, url, data, conf)
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    inquiryDelete(seqBoard) {
        return new Promise((resolve, reject) => {
            const url = _API + `/board/inquiry/delete`;
            const conf = {
                headers: _HEADER()
            };
            const data = {seqBoard: seqBoard}
            _AXIOS_HELPER(ENUM.HTTP_METHOD.PATCH, url, data, conf)
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    inquiryList() {
        return new Promise((resolve, reject) => {
            const url = _API + `/board/inquiry/list`;
            const conf = {
                headers: _HEADER()
            };
            _AXIOS_HELPER(ENUM.HTTP_METHOD.POST, url, {}, conf)
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }
}